var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { PrivateKeyType, } from '@interfaces/keys.interface';
import { addCaptionToLoading, addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { closeModal, openModal } from '@popup/multichain/actions/modal.actions';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { MultisigUtils } from '@popup/steem/utils/multisig.utils';
import ProposalUtils from '@popup/steem/utils/proposal.utils';
import ProxyUtils from '@popup/steem/utils/proxy.utils';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@steempro/steem-keychain-commons';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { MetadataPopup } from 'src/common-ui/metadata-popup/metadata-popup.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import FormatUtils from 'src/utils/format.utils';
const ProposalItem = ({ proposal, addToLoadingList, removeFromLoadingList, setErrorMessage, setSuccessMessage, activeAccount, onVoteUnvoteSuccessful, addCaptionToLoading, openModal, closeModal, }) => {
    const [isExpandablePanelOpened, setExpandablePanelOpened] = useState(false);
    const [usingProxy, setUsingProxy] = useState(false);
    const [keyType, setKeyType] = useState();
    useEffect(() => {
        init();
    }, []);
    useEffect(() => {
        if (activeAccount) {
            setKeyType(KeysUtils.getKeyType(activeAccount.keys.active, activeAccount.keys.activePubkey, activeAccount.account, activeAccount.account, KeychainKeyTypesLC.active));
        }
    }, [activeAccount]);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        let proxy = yield ProxyUtils.findUserProxy(activeAccount.account);
        setUsingProxy(proxy !== null);
    });
    const goTo = (link) => {
        chrome.tabs.create({ url: link });
    };
    const goToCreator = (creator) => {
        chrome.tabs.create({ url: `https://steempro.com/@${creator}` });
    };
    const processToggleSupport = (proposal, options) => __awaiter(void 0, void 0, void 0, function* () {
        if (proposal.voted) {
            addToLoadingList('popup_html_unvoting_for_proposal');
            const success = yield ProposalUtils.unvoteProposal(proposal.proposalId, activeAccount.name, activeAccount.keys.active, options);
            if (success) {
                if (success.isUsingMultisig) {
                    setSuccessMessage('multisig_transaction_sent_to_signers');
                }
                else {
                    onVoteUnvoteSuccessful();
                    setSuccessMessage('popup_html_proposal_unvote_successful');
                }
            }
            else {
                setErrorMessage('popup_html_proposal_unvote_fail');
            }
            removeFromLoadingList('popup_html_unvoting_for_proposal');
        }
        else {
            addToLoadingList('popup_html_voting_for_proposal');
            const success = yield ProposalUtils.voteForProposal(proposal.proposalId, activeAccount.name, activeAccount.keys.active, options);
            if (success) {
                if (success.isUsingMultisig) {
                    setSuccessMessage('multisig_transaction_sent_to_signers');
                }
                else {
                    setSuccessMessage('popup_html_proposal_vote_successful');
                    onVoteUnvoteSuccessful();
                }
            }
            else {
                setErrorMessage('popup_html_proposal_vote_fail');
            }
            removeFromLoadingList('popup_html_voting_for_proposal');
        }
    });
    const handleClickOnToggleSupport = (proposal) => __awaiter(void 0, void 0, void 0, function* () {
        if (usingProxy) {
            return;
        }
        if (keyType === PrivateKeyType.MULTISIG) {
            const twoFaAccounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, KeychainKeyTypes.active);
            let initialMetadata = {};
            for (const account of twoFaAccounts) {
                if (!initialMetadata.twoFACodes)
                    initialMetadata.twoFACodes = {};
                initialMetadata.twoFACodes[account] = '';
            }
            if (twoFaAccounts.length > 0) {
                openModal({
                    title: 'popup_html_transaction_metadata',
                    children: (React.createElement(MetadataPopup, { initialMetadata: initialMetadata, onSubmit: (metadata) => {
                            addCaptionToLoading('multisig_transmitting_to_2fa');
                            processToggleSupport(proposal, { metaData: metadata });
                            closeModal();
                        }, onCancel: () => closeModal() })),
                });
            }
        }
        else {
            processToggleSupport(proposal);
        }
    });
    return (React.createElement("div", { "data-testid": `proposal-item-expandable`, className: `proposal-item`, key: proposal.proposalId },
        React.createElement("div", { className: "title" },
            React.createElement("div", null,
                React.createElement("span", { "data-testid": `proposal-item-span-go-to-link-${proposal.creator}`, onClick: () => goTo(proposal.link) },
                    "#",
                    proposal.id,
                    " - ",
                    proposal.subject)),
            React.createElement(SVGIcon, { dataTestId: `proposal-item-icon-expandable-${proposal.creator}`, className: `more ${isExpandablePanelOpened ? 'open' : 'closed'}`, icon: SVGIcons.GOVERNANCE_PROPOSAL_EXPAND_COLLAPSE, onClick: () => setExpandablePanelOpened(!isExpandablePanelOpened) })),
        React.createElement("div", { className: "additional-info" },
            React.createElement("div", { className: "left-panel" },
                React.createElement("div", { className: "creator" },
                    React.createElement("img", { "data-testid": `proposal-item-image-go-to-creator-${proposal.creator}`, onClick: () => goToCreator(proposal.creator), src: `https://steemitimages.com/u/${proposal.creator}/avatar`, onError: (e) => {
                            e.target.onError = null;
                            e.target.src = '/assets/images/accounts.png';
                        } }),
                    React.createElement("span", { "data-testid": `proposal-item-span-go-to-creator-${proposal.creator}`, onClick: () => goToCreator(proposal.creator) }, getMessage('popup_html_proposal_by', [
                        proposal.creator,
                    ])))),
            React.createElement("div", { className: "upvote-button" },
                React.createElement(SVGIcon, { dataTestId: `proposal-item-icon-vote-unvote-${proposal.creator}`, onClick: () => handleClickOnToggleSupport(proposal), className: (proposal.voted ? 'voted' : 'not-voted') +
                        ' ' +
                        (usingProxy || !activeAccount.keys.active ? 'using-proxy' : ''), icon: SVGIcons.GOVERNANCE_PROPOSAL_UPVOTE, tooltipPosition: "left", tooltipMessage: !activeAccount.keys.active
                        ? 'popup_missing_key_proposal'
                        : usingProxy
                            ? 'html_popup_proposal_vote_error_proxy'
                            : undefined }))),
        isExpandablePanelOpened && (React.createElement("div", { "data-testid": `proposal-item-panel-expandable-${proposal.creator}`, className: isExpandablePanelOpened
                ? 'expandable-panel opened'
                : 'expandable-panel closed' },
            React.createElement(CustomTooltip, { message: `${proposal.startDate.format('L')} ${proposal.endDate.format('L')}`, skipTranslation: true },
                React.createElement("div", { className: "extra-info" },
                    React.createElement("div", { className: "value" },
                        React.createElement(SVGIcon, { icon: SVGIcons.GOVERNANCE_PROPOSAL_UPVOTE_VALUE }),
                        React.createElement("div", { "data-testid": "proposal-item-extra-info-value" }, proposal.totalVotes)),
                    React.createElement("div", null,
                        React.createElement(SVGIcon, { icon: SVGIcons.GOVERNANCE_PROPOSAL_DURATION }),
                        React.createElement("div", null, getMessage('popup_html_days_remaining', [
                            FormatUtils.withCommas(proposal.endDate
                                .diff(moment(new Date()), 'days')
                                .toString(), 0),
                        ]))),
                    React.createElement("div", null,
                        React.createElement(SVGIcon, { icon: SVGIcons.GOVERNANCE_PROPOSAL_BUDGET }),
                        React.createElement("div", null,
                            FormatUtils.withCommas(proposal.dailyPay.toString()),
                            "/",
                            getMessage('day'))))),
            React.createElement("div", { "data-testid": `proposal-item-extra-info-funded-${proposal.creator}`, className: `funded-chip ${proposal.funded}` }, getMessage(`popup_html_proposal_funded_option_${proposal.funded}`))))));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, {
    addToLoadingList,
    removeFromLoadingList,
    setErrorMessage,
    setSuccessMessage,
    addCaptionToLoading,
    openModal,
    closeModal,
});
export const ProposalItemComponent = connector(ProposalItem);
